import { LoaderState } from '../../types/Loaders/LoaderState';

export const createLoader = (loader: string) => ({
    state: LoaderState.PENDING,
    name: loader,
});
